import {fetchCalendarInvite} from '../util/cases';
import {downloadFile} from '../util/util';
import {useCallback} from 'react';
import {toast} from '@/components/ui/use-toast';

export const useAddToCalendar = (caseId: string) => {
    return useCallback(() => {
        fetchCalendarInvite(caseId).then((blob: Blob) => {
            if (!blob.size) {
                throw new Error('Calendar invite is empty');
            }

            downloadFile(blob, 'invite.ics');
        }).catch((err) => {
            console.error(err);
            toast({
                variant: 'destructive',
                title: 'Could not download calendar invite',
                description: 'Please try again later.',
            });
        })
    }, [caseId]);
}
